export default __webpack_public_path__ + "static/media/blue_ball_curve.28c615a0.jpg";